export enum EInputValidationResultType {
  //do not assign this
  _null,
  //available results you can assign to validation items
  Hint,
  Error,
  //do not assign this
  Valid
}